import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';
import debounce from '@utils/debounce';
const initProjectSlider = (element) => {
    var _a;
    const sliderElement = element.querySelector('.project-view__slider');
    if (!sliderElement)
        return;
    const slidesCount = ((_a = sliderElement.querySelectorAll('.project-view__image')) === null || _a === void 0 ? void 0 : _a.length) || 0;
    sliderElement.querySelectorAll('img[loading="lazy"]').forEach((img) => {
        var _a;
        const preloader = document.createElement('div');
        preloader.classList.add('swiper-lazy-preloader');
        preloader.classList.add('swiper-lazy-preloader-white');
        (_a = img.parentNode) === null || _a === void 0 ? void 0 : _a.appendChild(preloader);
    });
    const btnPrev = (element === null || element === void 0 ? void 0 : element.querySelector('.project-view__prev')) || null;
    const btnNext = (element === null || element === void 0 ? void 0 : element.querySelector('.project-view__next')) || null;
    let isDesktop = false;
    const options = {
        modules: [Navigation, Autoplay],
        loop: false,
        slidesPerView: 'auto',
        spaceBetween: 40,
        speed: 500,
        autoplay: false,
        navigation: {
            prevEl: btnPrev,
            nextEl: btnNext,
        },
        keyboard: {
            enabled: true,
            onlyInViewport: false,
        },
    };
    const autoplayDelay = sliderElement.hasAttribute('data-autoplay')
        ? +(sliderElement.getAttribute('data-autoplay') || 0)
        : 0;
    if (autoplayDelay) {
        options.autoplay = {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        };
    }
    let swiper;
    const updateCounter = () => {
        const counterElement = element.querySelector('.project-view__counter');
        if (counterElement && swiper) {
            counterElement.textContent = `${swiper.realIndex + 1}/${slidesCount}`;
        }
    };
    const initSlider = () => {
        isDesktop = matchMedia('(min-width: 1024px)').matches;
        if (swiper && !isDesktop) {
            swiper.destroy();
            delete sliderElement.swiper;
            swiper = null;
        }
        if (!swiper && isDesktop) {
            swiper = new Swiper(sliderElement, options);
            sliderElement.swiper = swiper;
            swiper.on('slideChange', updateCounter);
        }
    };
    const handleDocumentKeyDown = (event) => {
        if (!swiper)
            return;
        switch (event.key) {
            case 'ArrowLeft':
                swiper.slidePrev();
                break;
            case 'ArrowRight':
                swiper.slideNext();
                break;
            case 'Home':
                swiper.slideTo(0);
                break;
            case 'End':
                swiper.slideTo(slidesCount - 1);
                break;
        }
    };
    document.addEventListener('keydown', handleDocumentKeyDown);
    window.addEventListener('resize', debounce(initSlider, 300));
    initSlider();
    updateCounter();
};
document.querySelectorAll('.project-view').forEach((element) => {
    initProjectSlider(element);
});
